import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Currency = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("currency");
  const [data, setData] = useState(undefined);
  const [currCode, setCurrCode] = useState("");
  const [currDesc, setCurrDesc] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCurrCode, setEmptyCurrCode] = useState(false);
  const [emptyCurrDesc, setEmptyCurrDesc] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setCurrCode("");
    setCurrDesc("");
  };

  function setSelectedRow(rowid) {
    axios
      .get(`${BASE_URL}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setCurrCode(
          selectRowData.currency.currency_code
            ? selectRowData.currency.currency_code
            : ""
        );
        setCurrDesc(
          selectRowData.currency.currency_description
            ? selectRowData.currency.currency_description
            : ""
        );
        setBtnActive(false);
      });
  }

  const handleSave = async (event) => {
    if (currCode.length === 0) {
      toast.error("Country Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCurrCode(true);
      setEmptyInput(true);
    } else {
      setEmptyCurrCode(false);
    }

    if (currDesc.length === 0) {
      toast.error("Country Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCurrDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyCurrDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        currency_code: currCode,
        currency_description: currDesc,
      };
      const duplicate = await data.some((el) => el.CurrCode === currCode);
      if (duplicate !== true) {
        axios
          .post(`${BASE_URL}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This currency code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        currency_code: currCode,
        currency_description: currDesc,
      };
      axios
        .post(
          `${BASE_URL}${pageComponent}/update/${selectRowData.currency.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.currencies);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken, pageComponent]);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${BASE_URL}${pageComponent}/destroy/${selectRowData.currency.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Currency Code", "Currency Description"];
  const columns = ["currency_code", "currency_description"];

  const handleButtonClickPDF = () => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(columns) || columns.length === 0) {
      // Handle the scenario where the data or selected keys are invalid or empty
      toast.error("Invalid data or selected keys for export.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filteredRows = data.map(obj => {
      const filteredRow = {};
      columns.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          filteredRow[key] = obj[key];
        }
      });
      return filteredRow;
    });

    const doc = new jsPDF();
    const rows = filteredRows.map(obj => Object.values(obj));

    const columnStyles = {}; // Object to hold column styles

    // Set cell widths (adjust widths as needed)
    columns.forEach(key => {
      columnStyles[key] = { cellWidth: 30 }; // Change width as per your requirement
    });

    doc.autoTable({
      columns: tTitle.map(key => ({ header: key, dataKey: key })),
      body: rows,
      columnStyles,
      startY: 5, // Adjust the starting Y position for the table
      // ... other configuration options
    });

    // Save the PDF file
    const dateTime = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fileName = `Currency_PDF_Report_${dateTime}.pdf`;
    doc.save(fileName);
  };

  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Currency Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Curr. Code"
                    name="currCode"
                    value={currCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyCurrCode === true ? "border-red2" : ""}
                    onChange={(e) => setCurrCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Currency Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Curr. Name"
                    name="currDesc"
                    value={currDesc}
                    className={emptyCurrDesc === true ? "border-red2" : ""}
                    onChange={(e) => setCurrDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                {props.selectedAuthority && props.selectedAuthority.new === 1 ? (
                  <>
                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={selectRowData !== "" ? edditRow : handleSave}
                      disabled={btnActive}
                    >
                      Save
                    </Button>
                    <Button
                      className="ms-3"
                      variant="primary"
                      onClick={createNewRow}
                    >
                      New
                    </Button>
                  </>
                ) : null}
                {props.selectedAuthority && props.selectedAuthority.edit === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={edditRow}
                    disabled={btnActive}
                  >
                    Update
                  </Button>
                ) : null}
                {props.selectedAuthority && props.selectedAuthority.delete === 1 ? (
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={deleteRow}
                    disabled={btnActive}
                  >
                    Delete
                  </Button>
                ) : null}
                {props.selectedAuthority && props.selectedAuthority.print === 1 ? (
                  <Button className="ms-3" variant="primary" onClick={handleButtonClickPDF}>
                    Print
                  </Button>
                ) : null}
                {/* <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button> */}
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Currency;
